import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ff27b0b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0ff27b0b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff27b0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff27b0b')) {
      api.createRecord('0ff27b0b', component.options)
    } else {
      api.reload('0ff27b0b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0ff27b0b&scoped=true", function () {
      api.rerender('0ff27b0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/deliveryMonitor/index.vue"
export default component.exports